import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faComments, faVideo, faLaptopCode, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import "./Bumpups.css";

const Bumpups = () => {
  const cards = [
    {
      heading: "Local Videos",
      icon: faUpload,
    },
    {
      heading: "Video Chat",
      icon: faComments,
    },
    {
      heading: "AI YouTube",
      icon: faVideo,
    },
    {
      heading: "API",
      icon: faLaptopCode,
    },
  ];

  return (
    <div className="bumpups">
      <h2 className="bumpups-title">Do more with bumpups.com</h2>
      <p className="bumpups-description">
        Process your videos to deliver insights across all industries. Ask questions, request summaries, analyses, and more with Bump-1.0.
      </p>
      <div className="bumpups-grid">
        {cards.map((card, index) => (
          <div key={index} className="bumpups-card">
            <div className="bumpups-card-label">{card.heading}</div>
            <div className="bumpups-card-link">
              <FontAwesomeIcon icon={faArrowRight} className="bumpups-arrow-icon" />
              <span>Learn more</span>
            </div>
            <div className="bumpups-card-icon">
              <FontAwesomeIcon icon={card.icon} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bumpups;

